export default {
  itemSize: '24px',
  itemCellWidth: '38px',
  itemCellHeight: '32px',
  scrollItemWidth: '80px',
  scrollItemHeight: '40px',
  panelExtraFooterPadding: '8px 12px',
  panelActionPadding: '8px 12px',
  calendarTitlePadding: '0',
  calendarTitleHeight: '28px',
  arrowSize: '14px',
  panelHeaderPadding: '8px 12px',
  calendarDaysHeight: '32px',
  calendarTitleGridTempateColumns: '28px 28px 1fr 28px 28px',
  // type
  calendarLeftPaddingDate: '6px 12px 4px 12px',
  calendarLeftPaddingDatetime: '4px 12px',
  calendarLeftPaddingDaterange: '6px 12px 4px 12px',
  calendarLeftPaddingDatetimerange: '4px 12px',
  calendarLeftPaddingMonth: '0',
  // TODO: make it actually effective
  calendarLeftPaddingYear: '0',
  calendarLeftPaddingQuarter: '0',
  calendarLeftPaddingMonthrange: '0',
  calendarLeftPaddingQuarterrange: '0',
  calendarLeftPaddingYearrange: '0',
  calendarLeftPaddingWeek: '6px 12px 4px 12px',
  calendarRightPaddingDate: '6px 12px 4px 12px',
  calendarRightPaddingDatetime: '4px 12px',
  calendarRightPaddingDaterange: '6px 12px 4px 12px',
  calendarRightPaddingDatetimerange: '4px 12px',
  calendarRightPaddingMonth: '0',
  calendarRightPaddingYear: '0',
  calendarRightPaddingQuarter: '0',
  calendarRightPaddingMonthrange: '0',
  calendarRightPaddingQuarterrange: '0',
  calendarRightPaddingYearrange: '0',
  calendarRightPaddingWeek: '0'
};